module.exports = __webpack_public_path__ + "img/cu10.eb0b751c.jpg";